import { Module } from 'vuex';

import { paymentLinksService } from '@/services/payment-links/payment-links.service';
import { PaymentLink } from '@/services/payment-links/payment-links.types';
import { RootState } from '@/store';

export interface PaymentLinkState {
  paymentLink: PaymentLink;
  paymentLinkLoading: boolean;
}

const state: PaymentLinkState = {
  paymentLink: null,
  paymentLinkLoading: false
};

const options: Module<PaymentLinkState, RootState> = {
  namespaced: true,
  state: () => state,
  actions: {
    setPaymentLink: ({ commit, dispatch }, paymentLink: PaymentLink | string | number): Promise<void> => {
      if (typeof paymentLink === 'number' || typeof paymentLink === 'string') {
        return dispatch('getPaymentLinkById', paymentLink);
      }
      commit('paymentLink', paymentLink);
      if (paymentLink && (paymentLink as PaymentLink).id) {
        return dispatch('getPaymentLinkById', (paymentLink as PaymentLink).id);
      }
    },
    getPaymentLinkById: ({ commit, dispatch }, id: number): Promise<void> => {
      commit('paymentLinkLoading', true);

      return paymentLinksService
        .get(id)
        .then(paymentLink => paymentLink && commit('paymentLink', paymentLink))
        .catch(error => dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('paymentLinkLoading', false));
    },
    clearPaymentLink: ({ dispatch }): Promise<void> => {
      return dispatch('setPaymentLink', null);
    }
  },
  mutations: {
    paymentLink: (state, paymentLink: PaymentLink) => (state.paymentLink = paymentLink),
    paymentLinkLoading: (state, loading: boolean) => (state.paymentLinkLoading = loading)
  }
};

export default options;
